import classnames from 'classnames';
import React from 'react';
import { useState } from 'react';

import Icon from '../Icon/Icon';
import * as styles from './SearchBar.module.scss';

const SearchBar = ({ as: Comp = 'div', isBreakout, onSubmit, ...other }) => {
  const [ hasFocus, setFocus ] = useState(null);
  const className = classnames(styles.container, {
    [ styles.hasFocus ]: hasFocus,
    [ styles.isBreakout ]: isBreakout,
  });

  function handleKeyUp(e) {
    if (e.keyCode === 13 && onSubmit) {
      onSubmit(e.target.value);
    }
  }

  return (
    <Comp className={className} {...other}>
      <Icon className={styles.icon} name="search" />
      <input
        className={styles.field}
        type="search"
        placeholder="Enter search term..."
        onKeyUp={handleKeyUp}
        onFocus={(e) => setFocus(true)}
        onBlur={(e) => setFocus(false)}
      />
    </Comp>
  );
};

export default SearchBar;
